import _lib from '../_lib';
import active from './active/index';
import {MyAccountNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'myaccount';
  let activations = [
    {
      name: 'myaccount',
      test: api.messageIs(MyAccountNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};